import { BaseDTO } from './base-dto';
import { Organization } from './organization';

export class MarketLevel extends BaseDTO {
    Name: string;
    Organization: Organization;
    Parent: MarketLevel;
    Rank: number;
    MarketLevelName: string;
}
